/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignPlanToUser
 */
export interface AssignPlanToUser {
    /**
     * 
     * @type {string}
     * @memberof AssignPlanToUser
     */
    planId: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssignPlanToUser
     */
    addUserToEditors?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssignPlanToUser
     */
    sendEmail?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AssignPlanToUser
     */
    targetUserId: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssignPlanToUser
     */
    autoAssignDecks?: boolean;
}

/**
 * Check if a given object implements the AssignPlanToUser interface.
 */
export function instanceOfAssignPlanToUser(value: object): value is AssignPlanToUser {
    if (!('planId' in value) || value['planId'] === undefined) return false;
    if (!('targetUserId' in value) || value['targetUserId'] === undefined) return false;
    return true;
}

export function AssignPlanToUserFromJSON(json: any): AssignPlanToUser {
    return AssignPlanToUserFromJSONTyped(json, false);
}

export function AssignPlanToUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignPlanToUser {
    if (json == null) {
        return json;
    }
    return {
        
        'planId': json['planId'],
        'addUserToEditors': json['addUserToEditors'] == null ? undefined : json['addUserToEditors'],
        'sendEmail': json['sendEmail'] == null ? undefined : json['sendEmail'],
        'targetUserId': json['targetUserId'],
        'autoAssignDecks': json['autoAssignDecks'] == null ? undefined : json['autoAssignDecks'],
    };
}

export function AssignPlanToUserToJSON(json: any): AssignPlanToUser {
    return AssignPlanToUserToJSONTyped(json, false);
}

export function AssignPlanToUserToJSONTyped(value?: AssignPlanToUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'planId': value['planId'],
        'addUserToEditors': value['addUserToEditors'],
        'sendEmail': value['sendEmail'],
        'targetUserId': value['targetUserId'],
        'autoAssignDecks': value['autoAssignDecks'],
    };
}

